import { pagedQuery, toPaged, type IPagedCollection } from '@moko/utils';
import { internalFetch } from '../utils/fetchHelper';

export interface ICompanyHoliday {
  id: number;
  holidayDate: string;
  name: string;
  region: string;
  isActive: boolean;
}

export interface ICompanyHolidayBody {
  holidayDate: string;
  name: string;
  region: string;
  isActive: boolean;
}

const base = () => import.meta.env.VITE_BACKEND_API_URL as string;

export const getCompanyHolidays = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  _search?: string,
  filters?: string
): Promise<IPagedCollection<ICompanyHoliday>> =>
  toPaged<ICompanyHoliday>(
    await internalFetch(
      `${base()}/p/companyHolidays?${pagedQuery({
        pageSize,
        pageNo,
        orderBy,
        filters,
      })}`,
      'GET',
      abortController
    ),
    pageSize,
    pageNo
  );

export const getCompanyHoliday = async (
  abortController: AbortController,
  id: number
): Promise<ICompanyHoliday> =>
  (
    await internalFetch(
      `${base()}/p/companyHoliday/${id}`,
      'GET',
      abortController
    )
  ).companyHoliday;

export const getHolidayRegions = async (
  abortController: AbortController
): Promise<string[]> =>
  (await internalFetch(`${base()}/p/holidayRegions`, 'GET', abortController)) ??
  [];

export const createCompanyHoliday = (
  abortController: AbortController,
  body: ICompanyHolidayBody
): Promise<unknown> =>
  internalFetch(
    `${base()}/p/companyHoliday`,
    'POST',
    abortController,
    JSON.stringify(body)
  );

export const updateCompanyHoliday = (
  abortController: AbortController,
  id: number,
  body: ICompanyHolidayBody
): Promise<unknown> =>
  internalFetch(
    `${base()}/p/companyHoliday/${id}`,
    'PUT',
    abortController,
    JSON.stringify(body)
  );

export const deleteCompanyHoliday = (
  abortController: AbortController,
  id: number
): Promise<unknown> =>
  internalFetch(`${base()}/p/companyHoliday/${id}`, 'DELETE', abortController);
